module.exports = __webpack_public_path__ + "static/media/ic-search.0a494e98.svg";